import api from '../api'

const fetchHelpTopics = (params = {}) => {
  return api.get('/help_topics', { params: { ...params } })
}

const fetchHelpTopicsById = (id, params = {}) => {
  return api.get(`/help_topics/${id}`, { params: { ...params } })
}

const downloadHelpTopicApi = (url) => {
  return api.get(url, { responseType: 'blob' })
}

export { fetchHelpTopics, fetchHelpTopicsById, downloadHelpTopicApi }
